import { createFileRoute } from '@tanstack/react-router'
import { RelatoriosPage } from '@/pages/relatorios/RelatoriosPage'

export const Route = createFileRoute('/_auth/relatorios')({
  component: RelatoriosPage,
})
